(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    const customCartButton = document.querySelector('[data-fotn-cart-trigger]');
    const shopifyCartTrigger = document.querySelector('cart-drawer-component button[data-testid="cart-drawer-trigger"]');

    if (customCartButton) {
      customCartButton.addEventListener('click', () => {
        if (shopifyCartTrigger) {
          shopifyCartTrigger.click();
        } else {
          window.location.href = '/cart';
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
